import LinkComponent from "next/link";
import { forwardRef } from "react";
import ParameterComponent from "./Parameter";
import {
  Container,
  Heading,
  Icon,
  Subheading,
  Title,
  EcoLabel,
} from "./styles";
import ThumbnailComponent from "./Thumbnail";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Link = LinkComponent as any;
const Parameter = ParameterComponent as any;
const Thumbnail = ThumbnailComponent as any;

type Props = {
  slug: string;
  name: string;
  image: any;
  className?: string;
  subheading: string;
  param1: {
    label: string;
    value: string;
  };
  param2: {
    label: string;
    value: string;
  };
  eco: string;
};

const ProductCard = forwardRef<HTMLDivElement, Props>(function ProductCard(
  props,
  ref
) {
  const { className, slug, name, image, subheading, param1, param2, eco } =
    props;

  return (
    <Container ref={ref} className={className}>
      {!!eco && (
        <EcoLabel>
          <Icon /> <span>ecopositive</span>
        </EcoLabel>
      )}
      <Link href={"/products/" + slug} passHref>
        <Heading $isEco={!!eco}>
          <Title>{name}</Title>
        </Heading>
      </Link>
      <Subheading>{subheading}</Subheading>
      <Thumbnail image={image} />
      <Parameter {...param1} />
      <Parameter {...param2} />
    </Container>
  );
});

export default ProductCard;
